import { Action } from "redux"

import * as actions from "./actions"
import { buildNormalizedNameLUT } from "./searchprotocol"

export const initialState: Search.Search = {
    isInitialized: false,
    isShown: false,
    workspaceId: -1,
    normalizedNameLUT: {},
}

const ACTION_HANDLERS: {
    [action: string]: (state: Search.Search, props: Action) => Search.Search
} = {
    [actions.INITIALIZE]: (
        state,
        { smartSearchInitData, workspaceId }: actions.Initialize,
    ): Search.Search => ({
        ...state,
        normalizedNameLUT: !!smartSearchInitData
            ? buildNormalizedNameLUT(smartSearchInitData.fieldLabels)
            : {},
        workspaceId,
    }),

    [actions.SET_INITIALIZED]: (state) => ({
        ...state,
        isInitialized: true,
    }),

    [actions.UPDATE_VISIBILITY]: (
        state,
        { visibility }: actions.UpdateVisibility,
    ): Search.Search => ({
        ...state,
        isShown: visibility,
    }),
}

export default function reducer(
    state = initialState,
    action: Action,
): Search.Search {
    const handler: (state: Search.Search, action: Action) => Search.Search =
        ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
